import React, { useEffect, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from "react-router-dom";
import './EglFamilyWebview.scss'
import { ssoAPIHelper } from "../services/SSOAPIHelper";
import { createAction } from "utils";

function EglFamilyWebview({ isLogin, familyBookingUrl, bookingAccess }) {
  const dispatch = useDispatch()
  const history = useHistory()
  const ref = useRef()
  useEffect(() => {
    if (!isLogin) {
      const url = ssoAPIHelper.getLoginWebUri("zh-Hant", "/family_booking") + `&cancel_redirect_when_login_cancel=true`;
      window.location.href = url;
      return
    }
    dispatch(createAction("customization/getFamilyBookingList")())

    return () => {
      dispatch({ type: "customization/clearState" })
      console.log("return clean webview")
    };
  }
    , []
  );

  useEffect(() => {
    if (familyBookingUrl) {
      history.goBack()
      ref.current.click()
    }
  }, [familyBookingUrl])

  return (
    <div className='egl-loader-container'>
      <div className="egl-loader" />
      <button className='egl-loader-container-button' ref={ref} onClick={() => window.open(`${familyBookingUrl}?access_token=${bookingAccess}`)}>booking_list</button>
    </div>
  );
}

const mapStateToProps = (state) => ({
  isLogin: state.users.isLogin,
  familyBookingUrl: state.customization.familyBookingUrl,
  bookingAccess: state.customization.bookingAccess,
});

export default connect(mapStateToProps)(EglFamilyWebview);
